import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass';
import { PAGE_MARGINS } from '../hooks/layer-geometry';

// Darkens the trim/bleed margin a selected media group isn't allowed to move
// or resize into (see layer-geometry's PAGE_MARGINS/clampTranslate/
// clampResize) — purely a visual guide, so it only shows up while something
// is actually selected, and never intercepts pointer events itself.
const PageBoundaryGuide = ({ pageWidth, pageHeight, margins }) => {
  if (!pageWidth || !pageHeight) return null;

  const strips = [
    // top
    { left: 0, top: 0, width: pageWidth, height: margins.top },
    // bottom
    { left: 0, top: pageHeight - margins.bottom, width: pageWidth, height: margins.bottom },
    // left (between the top/bottom strips)
    { left: 0, top: margins.top, width: margins.left, height: pageHeight - margins.top - margins.bottom },
    // right (between the top/bottom strips)
    {
      left: pageWidth - margins.right,
      top: margins.top,
      width: margins.right,
      height: pageHeight - margins.top - margins.bottom,
    },
  ];

  return (
    <>
      {strips.map((strip, index) => (
        <Box
          key={index}
          data-testid="page-boundary-guide"
          sx={{
            position: 'absolute',
            left: `${strip.left}px`,
            top: `${strip.top}px`,
            width: `${strip.width}px`,
            height: `${strip.height}px`,
            background: 'rgba(0, 0, 0, 0.6)',
            pointerEvents: 'none',
            zIndex: 800,
          }}
        />
      ))}
    </>
  );
};

PageBoundaryGuide.propTypes = {
  pageWidth: PropTypes.number,
  pageHeight: PropTypes.number,
  margins: PropTypes.shape({
    left: PropTypes.number,
    right: PropTypes.number,
    top: PropTypes.number,
    bottom: PropTypes.number,
  }),
};

PageBoundaryGuide.defaultProps = {
  pageWidth: 0,
  pageHeight: 0,
  margins: PAGE_MARGINS,
};

export default React.memo(PageBoundaryGuide);
